export const elevation = {
  dropdown: '0px 8px 24px 12px rgba(6, 9, 14, 0.16)',
};
